import Service from '../../../services/Service';

class KgfbService extends Service {
    sendInformant(id) {
        return this.post(
            `kgfb/kgfb-send-calculation/?id=${id}`,
            { id },
        );
    }

    queryCalcCode(id, modozat, calcCode) {
        return this.get(
            `calculation/calculation-code/?id=${id}&modozat=${modozat}&code=${calcCode}`,
        );
    }

    queryCalcCodePost(data) {
        return this.post('calculation/calculation-code', data);
    }

    saveFutureClientData(data) {
        return this.post('kgfb/kgfb-ugyfel-data', data);
    }

    calculate(tid, id, biztositok) {
        // POST http://ujtarifa.sp/kgfb/kgfb-calculate/?id=5613439
        return this.post(`kgfb/kgfb-calculate/?id=${id}`, biztositok);
    }

    saveKieg(tid, id, data) {
        return this.post(`kgfb/kgfb-additionals/?id=${id}`, data);
    }

    saveCascoKieg(tid, id, data) {
        return this.post(`kgfb/casco-additionals/?id=${id}`, data);
    }

    getDijtajekoztato(id, modozat, rendezettseg) {
        return this.get(`kgfb/kgfb-igenyfelmero/?id=${id}${modozat === 4
            ? '&casco=1'
            : ''}&rendezettseg=${rendezettseg}`);
    }

    sendDijtajekoztatoMail(id, email, rendezes) {
        return this.post(`kgfb/kgfb-send-calculation/?id=${id}`, {
            id,
            email,
            rendezes,
        });
    }

    loadDijak(tid, id, tarifaId) {
        return this.get('kgfb/kgfb-calculate/?', { id, tarifa_id: tarifaId });
    }

    loadTarifa(id, tid, token) {
        if (id) {
            return this.get('kgfb/kgfb/?', { id });
        }
        return this.get('kgfb/kgfb/?', { token });
    }

    loadTarifaByToken(token) {
        return this.get('kgfb/kgfb/?', { token });
    }

    loadOffer(id) {
        return this.get('kgfb/kgfb-offer-data/?', { id });
    }

    saveDijak(id, tid, tarifaData) {
        return this.post('kgfb/kgfb-select-tarifa', { tarifaData });
    }

    getDijalkXML(id, biztositoId, modozat) {
        return this.get('kgfb/kgfb-calculate-info/?', {
            calculation_id: id, biztosito_id: biztositoId, modozat,
        });
    }

    save(id, tid, tarifaData, plainSave) {
        if (typeof id !== 'undefined' && !plainSave) {
            return this.post(`kgfb/kgfb?id=${id}`, tarifaData);
        }
        return this.post('kgfb/kgfb?', tarifaData);
    }

    saveOffer(id, tid, tarifaData) {
        return this.post(`kgfb/kgfb-offer-data?id=${id}`, tarifaData);
    }

    getOfferPdf(id, tarifaId) {
        return this.get('kgfb/kgfb-offer/?', { id, tarifa_id: tarifaId });
    }

    setDas(id, tarifaId, dasJogvedelem) {
        return this.post('kgfb/kgfb-set-das', {
            tarifaData: {
                id,
                tarifa_id: tarifaId,
                das_jogvedelem: dasJogvedelem,
            },
        });
    }

    setMapfre(id, tarifaId, mapfreAsszisztencia) {
        return this.post('kgfb/kgfb-set-mapfre', {
            tarifaData: {
                id,
                tarifa_id: tarifaId,
                mapfre_asszisztencia: mapfreAsszisztencia,
            },
        });
    }

    getBrokerData() {
        return this.get('kgfb/kgfb-broker-data', {});
    }

    offer(id, tarifaId) {
        return this.post('kgfb/kgfb-offer', {
            tarifaData: {
                kgfb: {
                    tarifa_id: tarifaId,
                    id,
                },
            },
        });
    }

    copyTarifa(id, tid, papirmentes, hibrid) {
        return this.postFormData('bn_tarifalo/foablak_kgfbinfo_tabs_4_tarifa_masol.php', {
            tarifa_id: tid,
            id,
            papirmentes,
            hibrid,
        });
    }

    hideBiztosito(id, tarifaId, modozat, biztositok) {
        return this.post('kgfb/kgfb-set-hiding', {
            id,
            tarifa_id: tarifaId,
            modozat,
            biztositok,
        });
    }

    loadEvfordTarifa(email, rendszam, alvazszam) {
        return this.get('kgfb/', {
            email,
            rendszam,
            alvazszam,
        });
    }

    setPapirmentes(id) {
        return this.post('kgfb/kgfb-set-papirmentes', {id});
    }

    saveRendezettseg(id, dijsorrend) {
        return this.post('kgfb/kgfb-set-dijtabla-order', {id, dijsorrend});
    }

    createOffer(id, tid) {
        return this.post('kgfb/kgfb-create-offer', { tarifaData: { kgfb: { tarifa_id: tid, id } } });
    }

    sendDealerMail(id, email) {
        return this.post('kgfb/kgfb-send-dealer-mail', {id, email});
    }

    setDealer(id) {
        return this.post('kgfb/kgfb-set-dealer', {id});
    }

    getOfferCheckData(id) {
        return this.get('kgfb/kgfb-offer-check-data?', {id});
    }

    saveAjanlatNyilatkozat(id, declarations) {
        return this.post(
            'kgfb/kgfb-save-ajanlat-nyilatkozat',
            {id, ajanlat_folyamat_nyilatkozatok: declarations}
        );
    }

    getDefaultData() {
        return this.get('kgfb/kgfb-default/?id=0');
    }

    getDataByToken(token) {
        return this.get(`kgfb/kgfb-data-by-token?token=${token}`);
    }

    getOvbUzletkoto(name) {
        return this.get(`ovbapi/uzletkoto/?name=${name}`);
    }
}

export default new KgfbService('/');
